import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getValue'
})
export class GetValuePipe implements PipeTransform {

  transform(value: any, language: string): string {
    if (!value || !value[language]) {
      return '';
    }

    return value[language];
  }

}
